import styled, {css, system, th} from 'quickstart/system'
import {fieldStyles} from 'quickstart/utils'
import {Radio as ReakitRadio} from 'reakit/Radio'

export const RadioField = styled.label`
  display: flex;
`

// prettier-ignore
export const Radio = styled(ReakitRadio)(
  ({connected, order = '-1', theme}) => css`
    ${
    // @ts-expect-error
    fieldStyles};
    position: relative;
    padding: 0;
    order: ${order};
    cursor: pointer;
    border-radius: 50%;
    transition: ${th('transitions.medium')};
    ${th('radios.radio.default')};

    &:after {
      content: ' ';
      position: absolute;
      top: 1px;
      right: 1px;
      bottom: 1px;
      left: 1px;
      border-radius: 50%;
      background-color: ${th(`fields.radio.checked.color`)};
      opacity: 0;
      transition: ${th('transitions.medium')};
    }

    &:checked:after {
      opacity: 1;
    }

    :disabled {
      cursor: not-allowed;
    }

    ${system};
  `,
)

export const Label = styled.div(
  ({checked, theme}) => css`
    ${th('radios.label.default')}
    ${checked && th('radios.label.checked')}
    vertical-align: text-top;
    transition: ${th('transitions.medium')};

    :disabled {
      cursor: not-allowed;
    }
  `,
)
